<template>
  <!-- 优惠券管理-优惠券配置-添加或编辑弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加优惠券' : '编辑优惠券'"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="preferential_type" label="优惠途径">
          <el-select
            v-model="dataForm.preferential_type"
            placeholder="请选择途径"
          >
            <el-option label="充值" :value="1"></el-option>
            <el-option label="商城" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reduction_type" label="折扣类型">
          <el-select v-model="dataForm.reduction_type" placeholder="请选择类型">
            <el-option label="百分比" :value="1"></el-option>
            <el-option label="固定金额" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reduction_way" label="优惠方式">
          <el-select v-model="dataForm.reduction_way" placeholder="请选择方式">
            <el-option label="折扣" :value="1"></el-option>
            <el-option label="赠送" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="优惠券名称">
          <el-input placeholder="请输入名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="operation_amount" label="花费金额">
          <el-input
            placeholder="请输入金额"
            v-model="dataForm.operation_amount"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="reduction_number"
          :label="dataForm.reduction_type == 1 ? '比例(%)' : '固定金额'"
        >
          <el-input
            placeholder="请输入数值"
            v-model="dataForm.reduction_number"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="days" label="失效天数">
          <el-input placeholder="请输入天数" v-model="dataForm.days">
          </el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="dataForm.status" placeholder="请选择状态">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="关闭" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import ImgUpload from '@/components/common/ImgUpload.vue'


export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        name: '',//优惠券名称
        reduction_type: 1,//折扣类型 1是百分比 2是固定金额
        reduction_way: 1,//优惠方式 1折扣 2是赠送
        preferential_type: 1,//优惠途径 1是充值 2商城
        days: '',//失效天数
        status: 1,//优惠券状态 1是正常 2是关闭
        operation_amount: '',//花费金额
        reduction_number: '',//比例或者金额
      },
      replyRules: {//规则验证
        reduction_type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ],
        reduction_way: [
          {
            required: true,
            message: '请选择方式',
            trigger: 'blur'
          }
        ],
        preferential_type: [
          {
            required: true,
            message: '请选择途径',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        days: [
          {
            required: true,
            message: '请输入天数',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      } else {
        this.dataForm = {
          name: '',//优惠券名称
          reduction_type: 1,//折扣类型 1是百分比 2是固定金额
          reduction_way: 1,//优惠方式 1折扣 2是赠送
          preferential_type: 1,//优惠途径 1是充值 2商城
          days: '',//失效天数
          status: 1,//优惠券状态 1是正常 2是关闭
          operation_amount: '',//花费金额
          reduction_number: '',//比例或者金额
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          //保存任务
          //表单验证后发起请求
          this.buttonLoading = true
          let params = this.dataForm
          if (this.type === 1) {
            postApiData('coupons', params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.$emit('refresh')
                this.closeDialog()
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.type === 2) {
            patchApiData(`coupons/${this.dataForm.id}`, params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.$emit('refresh')
                this.closeDialog()
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>